module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "statusList quoteLite"
  }, [_c('v-content', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-navigation-drawer', {
    staticClass: "rightDrawer",
    attrs: {
      "right": "",
      "absolute": "",
      "light": "",
      "width": "1000"
    },
    model: {
      value: (_vm.filterDrawer),
      callback: function($$v) {
        _vm.filterDrawer = $$v
      },
      expression: "filterDrawer"
    }
  }, [(_vm.filtersLoading == true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('h3', [_vm._v("FILTERS LOADING")])])], 1) : _vm._e(), _vm._v(" "), (_vm.filtersLoading == false) ? _c('v-layout', {
    staticClass: "filterContainer",
    staticStyle: {
      "padding-bottom": "100px",
      "overflow": "scroll !important"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "card__title modalTitle",
    attrs: {
      "lg12": ""
    }
  }, [_c('h3', [_vm._v("FILTERS")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "margin-bottom": "40px",
      "margin-top": "70px",
      "margin-left": "24px"
    },
    attrs: {
      "lg4": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": _vm.fncSearchQuoteLite
    }
  }, [_vm._v("Apply Filters")]), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-5 clearFilters",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncClearLiteFilters.apply(null, arguments)
      }
    }
  }, [_vm._v("Clear Filters")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "closeFiltersBtn",
    staticStyle: {
      "margin-bottom": "40px"
    },
    attrs: {
      "lg6": ""
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton btn",
    on: {
      "click": function($event) {
        _vm.filterDrawer = false
      }
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "filterContainerFilters",
    attrs: {
      "lg12": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "lg4": ""
    }
  }, [_c('label', [_c('strong', [_vm._v("Status")])]), _vm._v(" "), (_vm.fncCheckDone('status')) ? _c('a', {
    staticClass: "filterDone",
    staticStyle: {
      "margin-top": "5px"
    },
    on: {
      "click": function($event) {
        return _vm.fncLoadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "statusSelect",
    staticClass: "statusClick dropdown dashDroprep",
    staticStyle: {
      "width": "90%",
      "display": "block"
    },
    attrs: {
      "items": _vm.quotesLiteFilters.status,
      "item-value": "id",
      "item-text": "name",
      "autocomplete": "",
      "multiple": "",
      "single-line": ""
    },
    on: {
      "blur": function($event) {
        return _vm.fncCheckChange('status')
      },
      "input": function($event) {
        return _vm.fncCheckDropdowns('status')
      }
    },
    model: {
      value: (_vm.filterStatus),
      callback: function($$v) {
        _vm.filterStatus = $$v
      },
      expression: "filterStatus"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "lg4": ""
    }
  }, [_c('label', [_c('strong', [_vm._v("Store")])]), _vm._v(" "), (_vm.fncCheckDone('store')) ? _c('a', {
    staticClass: "filterDone",
    staticStyle: {
      "margin-top": "5px"
    },
    on: {
      "click": function($event) {
        return _vm.fncLoadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "storeSelect",
    staticClass: "dropdown dashDroprep",
    staticStyle: {
      "width": "90%",
      "display": "block"
    },
    attrs: {
      "items": _vm.quotesLiteFilters.store,
      "item-value": "id",
      "item-text": "name",
      "autocomplete": "",
      "multiple": "",
      "single-line": ""
    },
    on: {
      "blur": function($event) {
        return _vm.fncCheckChange('store')
      },
      "input": function($event) {
        return _vm.fncCheckDropdowns('store')
      }
    },
    model: {
      value: (_vm.filterStore),
      callback: function($$v) {
        _vm.filterStore = $$v
      },
      expression: "filterStore"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "lg4": ""
    }
  }, [_c('label', [_c('strong', [_vm._v("Department")])]), _vm._v(" "), (_vm.fncCheckDone('department')) ? _c('a', {
    staticClass: "filterDone",
    staticStyle: {
      "margin-top": "5px"
    },
    on: {
      "click": function($event) {
        return _vm.fncLoadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "departmentSelect",
    staticClass: "dropdown dashDroprep",
    staticStyle: {
      "width": "90%",
      "display": "block"
    },
    attrs: {
      "items": _vm.quotesLiteFilters.department,
      "item-value": "id",
      "item-text": "name",
      "autocomplete": "",
      "multiple": "",
      "single-line": ""
    },
    on: {
      "blur": function($event) {
        return _vm.fncCheckChange('department')
      },
      "input": function($event) {
        return _vm.fncCheckDropdowns('department')
      }
    },
    model: {
      value: (_vm.filterDepartment),
      callback: function($$v) {
        _vm.filterDepartment = $$v
      },
      expression: "filterDepartment"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "lg4": ""
    }
  }, [_c('label', [_c('strong', [_vm._v("Customer")])]), _vm._v(" "), (_vm.fncCheckDone('customer')) ? _c('a', {
    staticClass: "filterDone",
    staticStyle: {
      "margin-top": "5px"
    },
    on: {
      "click": function($event) {
        return _vm.fncLoadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "customerSelect",
    staticClass: "dropdown dashDroprep",
    staticStyle: {
      "width": "90%",
      "display": "block"
    },
    attrs: {
      "items": _vm.quotesLiteFilters.customer,
      "item-value": "id",
      "item-text": "name",
      "autocomplete": "",
      "multiple": "",
      "single-line": ""
    },
    on: {
      "blur": function($event) {
        return _vm.fncCheckChange('customer')
      },
      "input": function($event) {
        return _vm.fncCheckDropdowns('customer')
      }
    },
    model: {
      value: (_vm.filterCustomer),
      callback: function($$v) {
        _vm.filterCustomer = $$v
      },
      expression: "filterCustomer"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "lg4": ""
    }
  }, [_c('label', [_c('strong', [_vm._v("Vendor")])]), _vm._v(" "), (_vm.fncCheckDone('vendor')) ? _c('a', {
    staticClass: "filterDone",
    staticStyle: {
      "margin-top": "5px"
    },
    on: {
      "click": function($event) {
        return _vm.fncLoadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "vendorSelect",
    staticClass: "dropdown dashDroprep",
    staticStyle: {
      "width": "90%",
      "display": "block"
    },
    attrs: {
      "items": _vm.quotesLiteFilters.vendor,
      "item-value": "id",
      "item-text": "name",
      "autocomplete": "",
      "multiple": "",
      "single-line": ""
    },
    on: {
      "blur": function($event) {
        return _vm.fncCheckChange('vendor')
      },
      "input": function($event) {
        return _vm.fncCheckDropdowns('vendor')
      }
    },
    model: {
      value: (_vm.filterVendor),
      callback: function($$v) {
        _vm.filterVendor = $$v
      },
      expression: "filterVendor"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "lg4": ""
    }
  }, [_c('label', [_c('strong', [_vm._v("Company")])]), _vm._v(" "), (_vm.fncCheckDone('company')) ? _c('a', {
    staticClass: "filterDone",
    staticStyle: {
      "margin-top": "5px"
    },
    on: {
      "click": function($event) {
        return _vm.fncLoadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "companySelect",
    staticClass: "dropdown dashDroprep",
    staticStyle: {
      "width": "90%",
      "display": "block"
    },
    attrs: {
      "items": _vm.quotesLiteFilters.company,
      "item-value": "id",
      "item-text": "name",
      "autocomplete": "",
      "multiple": "",
      "single-line": ""
    },
    on: {
      "blur": function($event) {
        return _vm.fncCheckChange('company')
      },
      "input": function($event) {
        return _vm.fncCheckDropdowns('company')
      }
    },
    model: {
      value: (_vm.filterCompany),
      callback: function($$v) {
        _vm.filterCompany = $$v
      },
      expression: "filterCompany"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "lg4": ""
    }
  }, [_c('label', [_c('strong', [_vm._v("Originator")])]), _vm._v(" "), (_vm.fncCheckDone('originator')) ? _c('a', {
    staticClass: "filterDone",
    staticStyle: {
      "margin-top": "5px"
    },
    on: {
      "click": function($event) {
        return _vm.fncLoadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "originatorSelect",
    staticClass: "dropdown dashDroprep",
    staticStyle: {
      "width": "90%",
      "display": "block"
    },
    attrs: {
      "items": _vm.quotesLiteFilters.originator,
      "item-value": "id",
      "item-text": "name",
      "autocomplete": "",
      "multiple": "",
      "single-line": ""
    },
    on: {
      "blur": function($event) {
        return _vm.fncCheckChange('originator')
      },
      "input": function($event) {
        return _vm.fncCheckDropdowns('originator')
      }
    },
    model: {
      value: (_vm.filterOriginator),
      callback: function($$v) {
        _vm.filterOriginator = $$v
      },
      expression: "filterOriginator"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "lg4": ""
    }
  }, [_c('label', [_c('strong', [_vm._v("Project")])]), _vm._v(" "), (_vm.fncCheckDone('project')) ? _c('a', {
    staticClass: "filterDone",
    staticStyle: {
      "margin-top": "5px"
    },
    on: {
      "click": function($event) {
        return _vm.fncLoadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "projectSelect",
    staticClass: "dropdown dashDroprep",
    staticStyle: {
      "width": "90%",
      "display": "block"
    },
    attrs: {
      "items": _vm.quotesLiteFilters.project,
      "item-value": "id",
      "item-text": "name",
      "autocomplete": "",
      "multiple": "",
      "single-line": ""
    },
    on: {
      "blur": function($event) {
        return _vm.fncCheckChange('project')
      },
      "input": function($event) {
        return _vm.fncCheckDropdowns('project')
      }
    },
    model: {
      value: (_vm.filterProject),
      callback: function($$v) {
        _vm.filterProject = $$v
      },
      expression: "filterProject"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "lg4": ""
    }
  }, [_c('label', [_c('strong', [_vm._v("Service Type")])]), _vm._v(" "), (_vm.fncCheckDone('service_type')) ? _c('a', {
    staticClass: "filterDone",
    staticStyle: {
      "margin-top": "5px"
    },
    on: {
      "click": function($event) {
        return _vm.fncLoadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "serviceTypeSelect",
    staticClass: "dropdown dashDroprep",
    staticStyle: {
      "width": "90%",
      "display": "block"
    },
    attrs: {
      "items": _vm.quotesLiteFilters.serviceType,
      "item-value": "id",
      "item-text": "name",
      "autocomplete": "",
      "multiple": "",
      "single-line": ""
    },
    on: {
      "blur": function($event) {
        return _vm.fncCheckChange('service_type')
      },
      "input": function($event) {
        return _vm.fncCheckDropdowns('service_type')
      }
    },
    model: {
      value: (_vm.filterServiceType),
      callback: function($$v) {
        _vm.filterServiceType = $$v
      },
      expression: "filterServiceType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "lg4": ""
    }
  }, [_c('label', [_c('strong', [_vm._v("Linked Reps")])]), _vm._v(" "), (_vm.fncCheckDone('linked_user')) ? _c('a', {
    staticClass: "filterDone",
    staticStyle: {
      "margin-top": "5px"
    },
    on: {
      "click": function($event) {
        return _vm.fncLoadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "linkedSelect",
    staticClass: "dropdown dashDroprep",
    staticStyle: {
      "width": "90%",
      "display": "block"
    },
    attrs: {
      "items": _vm.quotesLiteFilters.linkedUser,
      "item-value": "id",
      "item-text": "name",
      "autocomplete": "",
      "multiple": "",
      "single-line": ""
    },
    on: {
      "blur": function($event) {
        return _vm.fncCheckChange('linked_user')
      },
      "input": function($event) {
        return _vm.fncCheckDropdowns('linked_user')
      }
    },
    model: {
      value: (_vm.filterLinkedUser),
      callback: function($$v) {
        _vm.filterLinkedUser = $$v
      },
      expression: "filterLinkedUser"
    }
  })], 1), _vm._v(" "), (_vm.objAuthorize.manufacturer == '16777962') ? _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "lg4": ""
    }
  }, [_c('label', [_c('strong', [_vm._v("Location")])]), _vm._v(" "), (_vm.fncCheckDone('location')) ? _c('a', {
    staticClass: "filterDone",
    staticStyle: {
      "margin-top": "5px"
    },
    on: {
      "click": function($event) {
        return _vm.fncLoadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "locationSelect",
    staticClass: "dropdown dashDroprep",
    staticStyle: {
      "width": "90%",
      "display": "block"
    },
    attrs: {
      "items": _vm.quotesLiteFilters.locations,
      "item-value": "id",
      "item-text": "name",
      "autocomplete": "",
      "multiple": "",
      "single-line": ""
    },
    on: {
      "blur": function($event) {
        return _vm.fncCheckChange('location')
      },
      "input": function($event) {
        return _vm.fncCheckDropdowns('location')
      }
    },
    model: {
      value: (_vm.filterLocation),
      callback: function($$v) {
        _vm.filterLocation = $$v
      },
      expression: "filterLocation"
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    ref: "searchField",
    staticClass: "quoteNumberSearchPanel",
    attrs: {
      "prepend-icon": "search",
      "label": _vm.fncQuoteSearchLabel(),
      "id": "quoteSearch",
      "value": _vm.searchQuoteReport,
      "solo": "",
      "single-line": ""
    },
    on: {
      "input": _vm.CheckEditable
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "dashGenerateRep qtGenerate clearSearch",
    on: {
      "click": function($event) {
        return _vm.fncClearSearchTop()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])]), _vm._v(" "), _c('v-btn', {
    staticClass: "dashGenerateRep qtGenerate searchBtn",
    on: {
      "click": function($event) {
        return _vm.fncSearchTop()
      }
    }
  }, [_vm._v("SEARCH")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "filterresetbtns": ""
    }
  }, [(_vm.searchQuoteReport != '' || _vm.liteFilterLoaded == false) ? _c('v-btn', {
    staticClass: "elevation-5",
    attrs: {
      "disabled": "",
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.filterDrawer = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("filter_alt")]), _vm._v("Filters Loading")]) : _c('v-btn', {
    staticClass: "elevation-5",
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.filterDrawer = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("filter_alt")]), _vm._v("Filters")]), _vm._v(" "), (_vm.fncShowLiteFilters()) ? _c('v-btn', {
    staticClass: "elevation-5 clearFilters",
    attrs: {
      "disabled": _vm.searchQuoteReport != ''
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncClearLiteFiltersSearch.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("filter_alt")]), _vm._v("Clear Filters")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "datefilters": ""
    }
  }, [_c('date-picker', {
    staticClass: "quoteDateRep dashDateRep",
    attrs: {
      "id": "dashDateRep",
      "valueType": "format",
      "placeholder": "Start Date",
      "format": "YYYY-MM-DD",
      "lang": "en",
      "not-after": _vm.disabledAfter
    },
    on: {
      "mousedown": _vm.fncClearFilterShadows,
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.reportStartDate),
      callback: function($$v) {
        _vm.reportStartDate = $$v
      },
      expression: "reportStartDate"
    }
  }), _vm._v(" "), (_vm.quoteReportLoaded == true && _vm.quotesLoaded == true) ? _c('span', {
    staticClass: "toRep"
  }, [_c('strong', [_vm._v("to")])]) : _vm._e(), _vm._v(" "), _c('date-picker', {
    staticClass: "quoteDateRep dashDateRep",
    attrs: {
      "id": "dashDateRep",
      "valueType": "format",
      "placeholder": "End Date",
      "format": "YYYY-MM-DD",
      "lang": "en",
      "not-after": _vm.disabledAfter
    },
    on: {
      "mousedown": _vm.fncClearFilterShadows,
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.reportEndDate),
      callback: function($$v) {
        _vm.reportEndDate = $$v
      },
      expression: "reportEndDate"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "goDate",
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        return _vm.fncSearchQuoteLiteClick()
      }
    }
  }, [_vm._v("GO")]), _vm._v(" "), (_vm.quoteReportLoaded == true && _vm.quotesLoaded == true) ? _c('span', {
    staticClass: "toRep"
  }, [_c('strong', [_vm._v("OR")])]) : _vm._e(), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown dashDroprep",
    attrs: {
      "label": _vm.fncFilterLabel(),
      "items": _vm.dateOptions,
      "item-value": "id",
      "item-text": "name",
      "autocomplete": "",
      "solo": "",
      "single-line": ""
    },
    on: {
      "mousedown": _vm.fncClearFilterShadows,
      "input": function($event) {
        return _vm.fncChangeDates()
      }
    },
    model: {
      value: (_vm.quoteFilter),
      callback: function($$v) {
        _vm.quoteFilter = $$v
      },
      expression: "quoteFilter"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "columnbuttons": ""
    }
  }, [_c('v-btn', {
    staticClass: "elevation-5",
    attrs: {
      "color": "info reloadButton"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncManageColumns()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("view_column")]), _vm._v("Manage Columns")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "refreshbuttons": ""
    }
  }, [_c('v-btn', {
    staticClass: "elevation-5",
    attrs: {
      "color": "info reloadButton"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncSearchNewQuotes.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("refresh")]), _vm._v("Refresh")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "downloadbuttons": ""
    }
  }, [_c('v-progress-circular', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.excelLoading == true),
      expression: "excelLoading == true"
    }],
    staticClass: "pt-3 loginLoader",
    attrs: {
      "indeterminate": "",
      "width": 20,
      "size": 20,
      "color": "grey"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.excelLoading == false),
      expression: "excelLoading == false"
    }],
    staticClass: "elevation-5 downloadButton",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncExportQuotes.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("download")]), _vm._v("Export")])], 1)], 1), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "clear": "both"
    },
    attrs: {
      "fluid": ""
    }
  }, [(_vm.quoteLiteLoaded == false) ? _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('h2', {
    staticStyle: {
      "padding-top": "10%"
    }
  }, [_c('center', [_vm._v("Loading Quotes"), _c('br'), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Please Wait")])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.quoteLiteLoaded == true) ? _c('v-tabs', {
    staticClass: "surveyTabs",
    attrs: {
      "slider-color": "grey"
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_vm._l((_vm.quotesLite), function(tab, i) {
    return (i != 'count') ? _c('v-tab', {
      key: _vm.tabKeys[i],
      staticClass: "tab",
      attrs: {
        "disabled": _vm.fncCheckDisabledTab(tab, i),
        "id": i,
        "ripple": ""
      },
      on: {
        "click": function($event) {
          return _vm.getTab(i, 'main')
        }
      }
    }, [_vm._v(_vm._s(_vm.fncFormatTabTitle(i, true)))]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.quotesLite), function(tab, n) {
    return _c('v-tab-item', {
      key: _vm.i,
      attrs: {
        "transition": false,
        "reverse-transition": false
      }
    }, [_c('v-tabs', {
      staticClass: "surveyTabs subTabs",
      attrs: {
        "slider-color": "grey"
      },
      model: {
        value: (_vm.activeTabSub),
        callback: function($$v) {
          _vm.activeTabSub = $$v
        },
        expression: "activeTabSub"
      }
    }, [_vm._l((_vm.quotesLite[n]), function(t, z) {
      return (_vm.i != 'count') ? _c('v-tab', {
        key: _vm.tabKeys[t],
        staticClass: "tab",
        attrs: {
          "id": t,
          "ripple": ""
        },
        on: {
          "click": function($event) {
            return _vm.getTab(z, 'sub')
          }
        }
      }, [_vm._v(_vm._s(_vm.fncFormatTabTitle(z, false)))]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.quotesLite[n]), function(a, b) {
      return _c('v-tab-item', {
        key: _vm.z,
        staticClass: "pl-4 pr-4 pt-4 pb-4",
        staticStyle: {
          "padding-top": "0px !important"
        },
        attrs: {
          "transition": false,
          "reverse-transition": false
        }
      })
    })], 2)], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.quoteLiteLoaded == true) ? _c('v-data-table', {
    ref: "sortableTable",
    staticClass: "elevation-1 quoteTable",
    attrs: {
      "no-data-text": "No matching records found.",
      "items": _vm.fncGetTabItems(),
      "loading": "true",
      "headers": _vm.headers,
      "search": _vm.searchQuoteReport,
      "rows-per-page-items": [20, 40, 60, 80, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "sortableRow",
          attrs: {
            "id": "rows"
          }
        }, [_c('td', [_c('div', {
          staticClass: "flex-buttons"
        }, [_c('a', {
          staticClass: "quoteDetailsBtn",
          on: {
            "click": function($event) {
              return _vm.fncFullQuote(props.item)
            }
          }
        }, [_vm._v("Quote Details")]), _vm._v(" "), (props.item.hasAttachment != null && props.item.hasAttachment != '' && props.item.hasAttachment != 'null') ? _c('a', {
          staticClass: "reportAttachment",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncQuoteSettings(props.item.id, props.item.quote_no, props.item)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons attachmentTick"
        }, [_vm._v("done")]), _c('i', {
          staticClass: "material-icons paperclip"
        }, [_vm._v("attach_file")])]) : _c('a', {
          staticClass: "reportAttachment",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncQuoteSettings(props.item.id, props.item.quote_no, props.item)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons paperclip",
          staticStyle: {
            "opacity": "1"
          }
        }, [_vm._v("attach_file")])]), _vm._v(" "), (props.item.hide_quote_edit == true) ? _c('a', {
          staticClass: "menu editQuoteIcon",
          attrs: {
            "title": "Edit Quote"
          },
          on: {
            "click": function($event) {
              return _vm.fncEditQuote(props.item)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803' && props.item.price == '0' && props.item.calculator_links != '' && props.item.calculator_links != 'null' && props.item.calculator_links != null) ? _c('a', {
          staticClass: "menu openCalcIcon",
          attrs: {
            "title": "Open Calculators"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncOpenCalculator(props.item)
            }
          }
        }) : _vm._e()])]), _vm._v(" "), _vm._l((_vm.liteColumns), function(item) {
          return (item.checked != false && item.text != '') ? _c('td', [(item.id == 'store') ? _c('span', {
            staticClass: "storeColumn",
            domProps: {
              "innerHTML": _vm._s(_vm.fncHighlightSearchText(props.item.branch))
            }
          }) : _vm._e(), _vm._v(" "), (item.id == 'service_type') ? _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.fncHighlightSearchText(_vm.fncGetType('service_type', props.item.service_type)))
            }
          }) : _vm._e(), _vm._v(" "), (item.id == 'quote_type') ? _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.fncHighlightSearchText(props.item.type))
            }
          }) : _vm._e(), _vm._v(" "), (item.id == 'quote_no') ? _c('div', [_c('span', {
            staticClass: "quoteNumber",
            domProps: {
              "innerHTML": _vm._s(_vm.fncHighlightSearchText(props.item.quote_no))
            }
          }), _c('br'), _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.fncHighlightSearchText(props.item.created))
            }
          })]) : _vm._e(), _vm._v(" "), (item.id == 'department') ? _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.fncHighlightSearchText(props.item.department))
            }
          }) : _vm._e(), _vm._v(" "), (item.id == 'customer_name') ? _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.fncHighlightSearchText(_vm.fncTextValue(props.item.name) + ' - ' + _vm.fncTextValue(props.item.surname)))
            }
          }) : _vm._e(), _vm._v(" "), (item.id == 'external_ref') ? _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.fncHighlightSearchText(props.item.external_ref))
            }
          }) : _vm._e(), _vm._v(" "), (item.id == 'grant_total') ? _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.fncHighlightSearchText('R' + props.item.grand_total.toFixed(2)))
            }
          }) : _vm._e(), _vm._v(" "), (item.id == 'kam') ? _c('div', {
            staticClass: "kamColumn"
          }, [_c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.fncHighlightSearchText(props.item.kam_string))
            }
          }), _vm._v(" "), (item.id == 'kam' && _vm.objAuthorize.manufacturer == '385889803' && _vm.objAuthorize.privileges.indexOf('CAN_SET_KAMS') != -1) ? _c('v-btn', {
            staticClass: "elevation-5",
            attrs: {
              "slot": "activator",
              "color": "info"
            },
            on: {
              "click": function($event) {
                return _vm.fncSetResponsibleUsers(props.item, 'kam')
              }
            },
            slot: "activator"
          }, [_vm._v("SET")]) : _c('span', [_vm._v("-")])], 1) : _vm._e(), _vm._v(" "), (item.id == 'coordinator') ? _c('div', {
            staticClass: "kamColumn"
          }, [_c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.fncHighlightSearchText(props.item.coordinator_string))
            }
          }), _vm._v(" "), (item.id == 'coordinator' && _vm.objAuthorize.manufacturer == '385889803' && _vm.objAuthorize.privileges.indexOf('CAN_SET_KAMS') != -1) ? _c('v-btn', {
            staticClass: "elevation-5",
            attrs: {
              "slot": "activator",
              "color": "info"
            },
            on: {
              "click": function($event) {
                return _vm.fncSetResponsibleUsers(props.item, 'coordinator')
              }
            },
            slot: "activator"
          }, [_vm._v("SET")]) : _c('span', [_vm._v("-")])], 1) : _vm._e(), _vm._v(" "), (item.id == 'designer') ? _c('div', {
            staticClass: "kamColumn"
          }, [_c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.fncHighlightSearchText(props.item.designer_string))
            }
          }), _vm._v(" "), (item.id == 'designer' && _vm.objAuthorize.manufacturer == '385889803' && _vm.objAuthorize.privileges.indexOf('CAN_SET_KAMS') != -1) ? _c('v-btn', {
            staticClass: "elevation-5",
            attrs: {
              "slot": "activator",
              "color": "info"
            },
            on: {
              "click": function($event) {
                return _vm.fncSetResponsibleUsers(props.item, 'designer')
              }
            },
            slot: "activator"
          }, [_vm._v("SET")]) : _c('span', [_vm._v("-")])], 1) : _vm._e(), _vm._v(" "), (item.id == 'status') ? _c('div', {
            staticClass: "statusColumn",
            staticStyle: {
              "display": "flex",
              "align-items": "center"
            }
          }, [_c('span', {
            staticClass: "statusText",
            attrs: {
              "id": _vm.fncSetId(props.item.id)
            },
            domProps: {
              "innerHTML": _vm._s(_vm.fncHighlightSearchText(props.item.status))
            }
          }), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('CANNOT_UPDATE_STATUS') == -1) ? _c('span', {
            on: {
              "click": function($event) {
                return _vm.fncEditStatusPopup(props.item)
              }
            }
          }, [_c('v-btn', {
            staticClass: "elevation-5",
            attrs: {
              "color": "info"
            }
          }, [_vm._v("UPDATE STATUS")])], 1) : _vm._e(), _vm._v(" "), _c('a', {
            attrs: {
              "href": "#"
            },
            on: {
              "click": function($event) {
                $event.preventDefault();
                return _vm.fncViewStatusHistory(props.item)
              }
            }
          }, [_c('i', {
            staticClass: "material-icons"
          }, [_vm._v("history")])])]) : _vm._e(), _vm._v(" "), (item.id == 'vendor_recipient') ? _c('span', {
            staticClass: "nowrap vendorRecipient"
          }, [(props.item.vendor_recipient != '') ? _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.fncHighlightSearchText(_vm.fncDotDotDot(props.item.vendor_recipient)))
            }
          }) : _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.fncHighlightSearchText('Not Set'))
            }
          }), _vm._v(" "), _c('v-btn', {
            staticClass: "elevation-5",
            attrs: {
              "color": "info"
            },
            on: {
              "click": function($event) {
                return _vm.fncEditVendorRecipient(props.item)
              }
            }
          }, [_vm._v("UPDATE")])], 1) : _vm._e(), _vm._v(" "), (item.id == 'customer_recipient') ? _c('span', {
            staticClass: "nowrap customerRecipient"
          }, [(props.item.customer_recipient != '') ? _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.fncHighlightSearchText(_vm.fncDotDotDot(props.item.customer_recipient)))
            }
          }) : _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.fncHighlightSearchText('Not Set'))
            }
          }), _vm._v(" "), _c('v-btn', {
            staticClass: "elevation-5",
            attrs: {
              "color": "info"
            },
            on: {
              "click": function($event) {
                return _vm.fncEditCustomerRecipient(props.item)
              }
            }
          }, [_vm._v("UPDATE")])], 1) : _vm._e(), _vm._v(" "), (item.id == 'customer_email') ? _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.fncHighlightSearchText(props.item.customer_email))
            }
          }) : _vm._e(), _vm._v(" "), (item.id == 'customer_tel') ? _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.fncHighlightSearchText(props.item.customer_telephone))
            }
          }) : _vm._e(), _vm._v(" "), (item.id == 'quote_type') ? _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.fncHighlightSearchText(props.item.quote_type))
            }
          }) : _vm._e(), _vm._v(" "), (item.id == 'originator_name') ? _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.fncHighlightSearchText(_vm.fncTextValue(props.item.repName) + ' ' + _vm.fncTextValue(props.item.repSurname)))
            }
          }) : _vm._e(), _vm._v(" "), (item.id == 'manufacturer_date') ? _c('div', {
            staticClass: "nowrap dateInstallation"
          }, [_c('date-picker', {
            staticClass: "quoteDateRep dashDateRep",
            staticStyle: {
              "min-width": "120px !important"
            },
            attrs: {
              "valueType": "format",
              "format": "YYYY-MM-DD",
              "minute-step": 01,
              "placeholder": "Manufacturer Date",
              "lang": "en"
            },
            on: {
              "change": function($event) {
                return _vm.handleChange($event, props.item, 'manufacturer')
              }
            },
            model: {
              value: (props.item.manufacturer_date_api),
              callback: function($$v) {
                _vm.$set(props.item, "manufacturer_date_api", $$v)
              },
              expression: "props.item.manufacturer_date_api"
            }
          }), _vm._v(" "), _c('span', [_c('a', {
            attrs: {
              "href": "#"
            },
            on: {
              "click": function($event) {
                $event.preventDefault();
                return _vm.fncShowDateHistory(props.item, 'manufacturer_date_change')
              }
            }
          }, [_c('i', {
            staticClass: "material-icons"
          }, [_vm._v("history")])])])], 1) : _vm._e()]) : _vm._e()
        })], 2)]
      }
    }], null, false, 3487390442)
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}